import { memo, useMemo } from 'react'
import { array, bool, func, node, object, string } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import FeatureAvailability from '../../containers/FeatureAvailability'
import FeatureBadge from '../../containers/FeatureAvailability/components/FeatureBadge'
import { TabItem, TopBar } from './styled-components'

const Tabs = ({
  tabItems,
  children,
  currentTab,
  onChange,
  hover,
  singleChild
}) => {
  const selectedIndex = useMemo(
    () => tabItems.findIndex((tabItem) => tabItem.slug === currentTab),
    [currentTab, tabItems]
  )

  const ActiveChild = useMemo(
    () => (selectedIndex > -1 ? children[selectedIndex] : children[0]),
    [selectedIndex]
  )

  return (
    <>
      <TopBar>
        {tabItems.map((tabItem, index) => {
          const isActive = currentTab
            ? tabItem.slug === currentTab
            : index === 0
          return (
            <TabItem
              key={tabItem.slug}
              active={isActive}
              onClick={() => onChange(tabItem)}
              hoverColor={hover?.color}
              hoverBgColor={hover?.bgColor}
              style={tabItem.style}
            >
              {tabItem.featureSlug && (
                <FeatureAvailability
                  featureSlug={tabItem.featureSlug}
                  render={({ isDisabled, requiredTier, loading, error }) => (
                    <>
                      {!tabItem.translated
                        ? (
                        <FormattedMessage id={tabItem.title} />
                          )
                        : (
                            tabItem.title
                          )}
                      {isDisabled() && (
                        <FeatureBadge
                          selected={isActive}
                          tier={requiredTier}
                          loading={loading}
                          error={error}
                        />
                      )}
                    </>
                  )}
                />
              )}
              {!tabItem.featureSlug && (
                <>
                  {!tabItem.translated
                    ? (
                    <FormattedMessage id={tabItem.title} />
                      )
                    : (
                        tabItem.title
                      )}
                </>
              )}
            </TabItem>
          )
        })}
      </TopBar>
      {/* TODO: Maybe render all on initial an use css to show activeChild */}
      {singleChild ? children : ActiveChild}
    </>
  )
}

Tabs.propTypes = {
  tabItems: array.isRequired,
  children: node,
  currentTab: string,
  onChange: func.isRequired,
  hover: object,
  singleChild: bool
}

export default memo(Tabs)
